import type { FileForProcessing } from '../../../Model/index.js'
import type { SampleOperationResult } from '../../Page/HomePage/Modals/CSVModalTypes.js'

export function generateSampleNames(samples: FileForProcessing[]): SampleOperationResult {
  const ops: SampleOperationResult = {
    result: [],
    errors: [],
    warnings: [],
  }

  samples.forEach((sample, index) => {
    if (!sample.sampleMetadata) {
      ops.result.push({
        op: "CreateMetadata",
        orderId: sample.orderId!,
        poolId: sample.poolId,
        metadata: {
          sampleId: sample.id,
          customerSampleName: deriveName(sample, index),
        }
      })
    } else if (!sample.customerSampleName) {
      ops.result.push({
        op: "UpdateMetadata",
        orderId: sample.orderId!,
        poolId: sample.poolId,
        metadata: {
          ...sample.sampleMetadata,
          customerSampleName: deriveName(sample, index),
        }
      })
    }
  })
  return ops
}

function deriveName(sample: FileForProcessing, index: number): string {
  return `S_${index}`
}